<template>
    <div class="bg">
        <div class="container" v-if="!loadEnd">
            <div class="text">
                <Loading :width="widthLoad"></Loading>
                {{'三维场景加载中... '}}
            </div>
            <div class="exit" @click="$router.go(-1)">退出三维看板</div>
        </div>
        <iframe class='iframe' name="3D" frameborder="0" width="100%" height="100%" ref="iframeDom" :src="url " allowfullscreen="true"></iframe>
        <!-- <iframe class='iframe' name="3D" frameborder="0" width="100%" height="100%" ref="iframeDom" src="http://www.energydt.cn:38080/aaaaaaa/" allowfullscreen="true"></iframe> -->
    </div>
</template>

<script>
    import Loading from './Loading'
    import {
        GetProJectInfo,
    } from "@/api/common" 
    export default {
        name: "ThreeD",
        components: {
            Loading,
        },
        data() {
            return {
                url: '',
                loadEnd: false,
                width: 0,
                timer: null,
                page:''
            }
        },
        computed:{
            widthLoad(){
                let width = this.width < 100 ? this.width : 100
                return width
            }
        },
        watch:{
            widthLoad(width){
                let that = this
                if(width == 100){
                    this.timer = setTimeout(()=>{
                            that.loadEnd = true
                            that.iframeWin.postMessage({
                                cmd: "3Dstart",
                            },"*");
                        },1000)
                }
            }
        },
        mounted() {
            let to = window.location.href.split('/')
            this.page = to[to.length - 1]
            console.log(this.page);
            GetProJectInfo().then(res => {
                console.log(res);
                    this.url = res.data.data.project.webUrl
                    // this.url = res.data.data.project.webUrl + '?' +this.page
                    // this.url = 'http://192.168.33.198:8080/#/?' + this.page
                    console.log('---------------------------------------------');
                    console.log(res);
                     
                }),
                this.iframeWin = this.$refs.iframeDom.contentWindow;
                window.addEventListener("message", this.handleMessage);
        },
        beforeDestroy() {
            window.removeEventListener("message", this.handleMessage);
            this.timer && clearTimeout(this.timer)
            this.timer && (this.timer = null)
        },
        methods: {
            handleMessage(event) {
                const data = event.data;
                switch (data.cmd) {
                    case "exit":
                        this.$router.push('/SubstationManagement')
                        break
                    case "loadEnd":
                        this.width = 100
                        
                        break
                    case "loadProgress":
                        console.log(data.value);
                        this.width = data.value * 4    // 这里加速三维进入 动画 ，
                        break
                }
            }
        }
    }
</script>

<style lang='less' scoped>
    .bg {
        width: 100vw;
        height: 100vh;
        background: #000;
        position: fixed;
        top: 0;
        left: 0;
    }

    .container {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-image: url('../../assets/img/threebj.png');
        background-size: 100% 100%;
        color: white;
        // opacity: 0.7;

        .text {
            position: fixed;
            top: 85%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: -1;
            font-size: 30rem;
            text-shadow: 0 0 20px #0D94FF , 0 0 20px #0D94FF , 0 0 20px #0D94FF ,;
            width: 40vw;
            height: 15vh;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }

        .exit {
            position: fixed;
            right: 80px;
            top: 50px;
            font-size: 30rem;
            cursor: pointer;
        }
    }
</style>